import { Box, Flex, Image, ListItem, Text, UnorderedList } from "@chakra-ui/react";
import image1Path from "../../assets/image/rs=w_600,h_600,cg_true.webp";
import image2Path from "../../assets/image/rs=w_600,cg_true.webp";
import image3Path from "../../assets/image/rs=w_600,h_600,cg_true (1).webp";

function About() {
  return (
    <>
      <Box marginLeft={"16%"} marginTop={"30px"}>
        <Text
          style={{ textTransform: "uppercase" }}
          fontFamily={"Lato, arial, sans-serif"}
          color={"black"}
          fontSize={"20px"}
          fontWeight={"font-weight: 400"}
          as="b"
        >
          About Going Solo
        </Text>
      </Box>

      <Flex flexDirection={"column"} alignItems={"center"}>
        <Box
          width={"70%"}
          height={"1px"}
          bg="#363B52"
          marginTop={2}
        />
        <Flex
          flexDirection={"column"}
          marginTop={"40px"}
          width={"70%"}
          gap={"50px"}
        >
          <Flex
            flexDirection={{ base: "column", md: "row" }}
            justifyContent={"flex-start"}
            alignItems={"center"}
            gap={{ base: "20px", md: "40px" }}
          >
            <Box width={{ base: "100%", md: "60%" }} maxWidth={"600px"}>
              <Image width={"100%"} src={image1Path} />
            </Box>
            <Box flex={1}>
              <Flex flexDirection={"column"} gap={{ base: "8px", md: "15px" }}>
                <Box>
                  <Text fontSize={"1.4em"} fontWeight="500" userSelect={"text"}>
                    What is Going Solo
                  </Text>
                </Box>
                <Box>
                  <Text userSelect={"text"}>
                    Going Solo is an app designed for solo travelers worldwide,
                    connecting individuals from various corners of the globe.
                    Primarily targeting the younger generation of travelers and
                    backpackers aged 18-30, the app creates lifelong friendships
                    among like-minded adventurers who share a passion for travel
                    and seeking thrilling experiences.
                  </Text>
                </Box>
              </Flex>
            </Box>
          </Flex>
          <Flex
            flexDirection={{ base: "column-reverse", md: "row" }}
            justifyContent={{ base: "flex-start", md: "flex-end" }}
            gap={{ base: "20px", md: "40px" }}
          >
            <Box flex={1}>
              <Flex flexDirection={"column"} gap={{ base: "8px", md: "15px" }}>
                <Box>
                  <Text fontSize={"1.4em"} fontWeight="500" userSelect={"text"}>
                    How do I use Going Solo
                  </Text>
                </Box>
                <Box>
                  <Text userSelect={"text"}>
                    Going Solo offers a straightforward user experience with its
                    key features:
                  </Text>
                </Box>
                <Box>
                  <UnorderedList>
                    <ListItem>
                      <Box>
                        <Text fontWeight={600} userSelect={"text"}>
                          Home Page:
                        </Text>
                      </Box>
                      <Box>
                        <Text userSelect={"text"}>
                          The home page displays solo travelers near you and
                          public groups in your current location. You have the
                          option to create your own group that others in the
                          area can freely join. You can also create a private
                          group which will only show for you and the others you
                          have invited to it.
                        </Text>
                      </Box>
                    </ListItem>
                    <ListItem>
                      <Box>
                        <Text fontWeight={600} userSelect={"text"}>
                          Future Trip Page:
                        </Text>
                      </Box>
                      <Box>
                        <Text userSelect={"text"}>
                          If you have a future trip in mind, you can put in your
                          planned destination and set of dates, and a list of
                          travelers who have saved the same destination with at
                          least one of the same dates in the range will appear.
                          Here, you can discuss your trip, make arrangements
                          together, and plan your adventures. You can also
                          create and join public groups associated with your
                          future trip.
                        </Text>
                      </Box>
                    </ListItem>
                    <ListItem>
                      <Box>
                        <Text fontWeight={600} userSelect={"text"}>
                          Popular Trips:
                        </Text>
                      </Box>
                      <Box>
                        <Text userSelect={"text"}>
                          For travel inspiration, you can visit the popular
                          trips section. It showcases trips that have been saved
                          by multiple users. You can freely join groups
                          associated with these trips, explore what other
                          travelers are planning, and gain insights for your own
                          travel plans.
                        </Text>
                      </Box>
                    </ListItem>
                    <ListItem>
                      <Box>
                        <Text fontWeight={600} userSelect={"text"}>
                          Personal Profile:
                        </Text>
                      </Box>
                      <Box>
                        <Text userSelect={"text"}>
                          You can create a personal profile where other users
                          can see your favorite travel photos. You can follow
                          users in your location or on your planned trip, browse
                          their past and current travel photos, and engage in
                          one-on-one messaging.
                        </Text>
                      </Box>
                    </ListItem>
                  </UnorderedList>
                  <Text userSelect={"text"}>
                    Going Solo simplifies the process of connecting with fellow
                    travelers, planning future trips, exploring popular
                    destinations, and showcasing your own travel experiences.
                  </Text>
                </Box>
              </Flex>
            </Box>
            <Box width={{ base: "100%", md: "60%" }} maxWidth={"600px"}>
              <Image width={"100%"} src={image2Path} />
            </Box>
          </Flex>
          <Flex
            flexDirection={{ base: "column", md: "row" }}
            justifyContent={"flex-start"}
            alignItems={"center"}
            gap={{ base: "20px", md: "40px" }}
          >
            <Box width={{ base: "100%", md: "60%" }} maxWidth={"600px"}>
              <Image width={"100%"} src={image3Path} />
            </Box>

            <Box flex={1}>
              <Flex flexDirection={"column"} gap={{ base: "8px", md: "15px" }}>
                <Box>
                  <Text fontSize={"1.4em"} fontWeight="500" userSelect={"text"}>
                    What is the goal of the app
                  </Text>
                </Box>
                <Box>
                  <Text userSelect={"text"}>
                    Going Solo alleviates the fear that solo travel will lead to
                    loneliness. It elevates the overall travel experience by
                    bringing you to people that you otherwise would have never
                    met. One of the most remarkable aspects of solo travel is
                    the connections made along the way, and Going Solo makes
                    this process effortless. Solo travelers often share common
                    values, and the app serves as a platform to connect
                    like-minded individuals, fostering a sense of camaraderie in
                    a secure, and user-friendly manner.
                  </Text>
                </Box>
              </Flex>
            </Box>
          </Flex>
        </Flex>
      </Flex>
    </>
  );
}

export default About;
